import PropTypes from "prop-types";
import React, { Component } from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import { FormattedMessage, injectIntl } from "react-intl";
import ObjectUtils, { coalesce } from "../../../utils/ObjectUtils";
import { findNumberOfQuestionsByType, isAnswered } from "../../../utils/QuestionUtils";
import { visibleCollection } from "../../../utils/TriggerUtil";

/**
 * The progress component which represents progress of running survey (how many questions are answered).
 */
class Progress extends Component {
  countQuestions(visiblePages, answeredQuestions, triggerState) {
    let questionCount = 0;
    let answeredCount = 0;
    let { getDeepProperty } = ObjectUtils;
    let answerIndex = ObjectUtils.indexByProperty(answeredQuestions, "name");
    visiblePages.forEach((page) => {
      let visibleQuesitons = visibleCollection(page.questions, triggerState);
      let numberOfInfoMessages = findNumberOfQuestionsByType(visibleQuesitons, "infoMessage");
      let numberOfSAPQuestions = findNumberOfQuestionsByType(visibleQuesitons, "projectData");
      questionCount = questionCount + visibleQuesitons.length - numberOfInfoMessages - numberOfSAPQuestions;
      //calculate count of answered question which is visible, for the page.
      visibleQuesitons.forEach((question) => {
        let idx = coalesce(getDeepProperty(answerIndex, question.name, "indexes", 0), -1);
        if (idx > -1) {
          let questionResult = getDeepProperty(answeredQuestions, idx);
          if (isAnswered(question, questionResult)) {
            answeredCount++;
          }
        }
      });
    });
    return {
      questionCount,
      answeredCount
    };
  }

  render() {
    let element = null;
    const { visiblePages, surveyCurrentPage, triggerState, surveyResult, pageIndex } = this.props;
    if (visiblePages && surveyCurrentPage) {
      let page = surveyCurrentPage;
      let counts = this.countQuestions(visiblePages, surveyResult.questions, triggerState);
      element = (
        <div className={"d-flex align-items-center flex-nowrap flex-fill gap-lg ms-5 m-sm-2"}>
          <span>
            <FormattedMessage id="user.surveyView.question" /> {counts.answeredCount}{" "}
            <FormattedMessage id="user.surveyView.from" /> {counts.questionCount}
          </span>
          <ProgressBar
            style={{ maxWidth: 150 }}
            now={(counts.answeredCount / counts.questionCount) * 100}
            variant={"warning"}
            className={"bg-light flex-fill"}
          />
          <span>
            <FormattedMessage id="user.surveyView.menuPages" /> {pageIndex + 1}.{!page.title ? page.name : page.title}
          </span>
        </div>
      );
    }
    return element;
  }
}

Progress.propTypes = {
  surveyResult: PropTypes.object.isRequired,
  triggerState: PropTypes.array,
  visiblePages: PropTypes.array,
  surveyCurrentPage: PropTypes.object,
  pageIndex: PropTypes.number
};

export default injectIntl(Progress);
